import { Store } from "@core/storage/storage";
import { Observable, observable } from "micro-observables";

export enum FeatureToggle {
	DeactivateAnalytics = "DeactivateAnalytics",
}

export const featureToggles = Object.keys(FeatureToggle);

export type FeatureTogglesRecord = Record<FeatureToggle, boolean>;

const DEFAULT_FEATURE_TOGGLES: FeatureTogglesRecord = {
	[FeatureToggle.DeactivateAnalytics]: false,
};

export class FeatureTogglesManager {
	private readonly _featureToggles = observable<Record<FeatureToggle, boolean>>(DEFAULT_FEATURE_TOGGLES);
	readonly featureToggles = this._featureToggles.readOnly();

	constructor(private readonly featureTogglesStore: Store<FeatureTogglesRecord>) {}

	async init(): Promise<void> {
		const storedFeaturesToggle = this.featureTogglesStore.getItem();
		this._featureToggles.set({ ...DEFAULT_FEATURE_TOGGLES, ...storedFeaturesToggle });
	}

	setFeatureToggleValue(featureToggle: FeatureToggle, enabled: boolean): void {
		const currentRecord = { ...this._featureToggles.get(), [featureToggle]: enabled };
		this._featureToggles.set(currentRecord);
		this.featureTogglesStore.setItem(currentRecord);
	}

	hasFeature(featureToggle: FeatureToggle): Observable<boolean> {
		return this.featureToggles.select(toggles => toggles[featureToggle]);
	}

	reset(): void {
		this.featureTogglesStore.setItem(DEFAULT_FEATURE_TOGGLES);
		this._featureToggles.set(DEFAULT_FEATURE_TOGGLES);
	}
}
